"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _emotion = require("emotion");
var _reactComponents = require("@cimpress/react-components");
var _reactStreamlineIcons = require("@cimpress-technology/react-streamline-icons");
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var invoicingStatusButtonClass = (0, _emotion.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: Transparent;\n  border: none;\n  outline: none;\n  padding: 0;\n  color: ", ";\n  cursor: pointer;\n  &:hover {\n    text-decoration: underline;\n  }\n"])), _reactComponents.colors.info.base);
var tooltipClass = (0, _emotion.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-top: 4px;\n"])));
var InvoicingStatusButton = function InvoicingStatusButton(props) {
  return /*#__PURE__*/_react["default"].createElement(_reactComponents.FlexBox, {
    middle: true,
    marginX: 's'
  }, /*#__PURE__*/_react["default"].createElement("span", {
    onClick: function onClick() {
      return openInNewTab(props === null || props === void 0 ? void 0 : props.invoicingLink);
    },
    className: (props === null || props === void 0 ? void 0 : props.invoicingLink) !== '' && invoicingStatusButtonClass
  }, props === null || props === void 0 ? void 0 : props.buttonText), /*#__PURE__*/_react["default"].createElement(_reactComponents.Tooltip, {
    contents: props === null || props === void 0 ? void 0 : props.tooltipText
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: tooltipClass
  }, /*#__PURE__*/_react["default"].createElement(_reactStreamlineIcons.IconQuestionCircle, {
    color: _reactComponents.colors.info.base
  }))));
};
var openInNewTab = function openInNewTab(url) {
  if (url !== '') {
    window.open(url, '_blank', 'noreferrer');
  }
};
InvoicingStatusButton.propTypes = {
  invoicingLink: _propTypes["default"].string,
  tooltipText: _propTypes["default"].string,
  buttonText: _propTypes["default"].string
};
var _default = InvoicingStatusButton;
exports["default"] = _default;